import { z } from 'zod'

import {
  BidDomainSelectModelSchema,
  MakerProjectPaymentTermsAgreementSchema,
  MakerTermsAgreementSchema,
} from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { SelectBidOutputSchema } from './select-bid.models.ts'

export const SubmitBidInputSchema = BidDomainSelectModelSchema.pick({
  bidId: true,
  amount: true,
  pitch: true,
})
  .extend({
    agreements: z.tuple([
      MakerTermsAgreementSchema,
      MakerProjectPaymentTermsAgreementSchema,
    ]),
  })
  .required()

export type SubmitBidInput = ZodInfer<typeof SubmitBidInputSchema>

export const SubmitBidOutputSchema = SelectBidOutputSchema

export type SubmitBidOutput = ZodInfer<typeof SubmitBidOutputSchema>
